// Debug helper: persist console logs to localStorage and optionally block reloads
export {};

(function setupDebugHelpers() {
  if ((window as any).__debugHelpersInstalled) return;
  (window as any).__debugHelpersInstalled = true;

  const MAX_LOGS = 500;
  const storageKey = '__debug_logs__';
  const oldLog = console.log.bind(console);

  // Initialize stored logs array
  try {
    const existing = localStorage.getItem(storageKey);
    if (!existing) localStorage.setItem(storageKey, JSON.stringify([]));
  } catch (e) {
    // ignore
  }

  console.log = (...args: any[]) => {
    try {
      const raw = localStorage.getItem(storageKey) || '[]';
      const arr = JSON.parse(raw);
      arr.push([new Date().toISOString(), ...args]);
      if (arr.length > MAX_LOGS) arr.splice(0, arr.length - MAX_LOGS);
      localStorage.setItem(storageKey, JSON.stringify(arr));
    } catch (e) {
      // ignore storage errors
    }
    oldLog(...args);
  };

  // Expose helpers
  (window as any).showDebugLogs = function showDebugLogs() {
    try {
      const raw = localStorage.getItem(storageKey) || '[]';
      const arr = JSON.parse(raw);
      // print nicely
      console.table(arr.map((r: any[]) => ({ time: r[0], message: r.slice(1) })));
    } catch (e) {
      console.error('showDebugLogs error', e);
    }
  };

  (window as any).clearDebugLogs = function clearDebugLogs() {
    try { localStorage.removeItem(storageKey); console.log('Debug logs cleared'); } catch (e) {}
  };

  // Blocking reload: controlled via localStorage flag 'prevent_reload'
  const beforeUnloadHandler = (e: BeforeUnloadEvent) => {
    const prevent = localStorage.getItem('prevent_reload');
    if (prevent === '1' || prevent === 'true') {
      e.preventDefault();
      e.returnValue = '';
      return '';
    }
    return undefined;
  };

  window.addEventListener('beforeunload', beforeUnloadHandler);

  // Helper to toggle prevent_reload from console
  (window as any).enablePreventReload = function enablePreventReload() {
    localStorage.setItem('prevent_reload', '1');
    console.log('prevent_reload enabled — next reload will be blocked/prompted');
  };
  (window as any).disablePreventReload = function disablePreventReload() {
    localStorage.removeItem('prevent_reload');
    console.log('prevent_reload disabled');
  };

})();
